export default {"src":"/_next/static/media/id.e65d9b99.svg","height":480,"width":640};